import React, { useState,useContext,useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import { deleteShortcut } from '../../api/shortcut';
import { useFormik } from 'formik';
import * as Yup from 'yup'; 
import FInputt from "../../components/FInputt/FInputt";
import { useLocation, useNavigate } from "react-router-dom";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";
import FContainer from "../../components/FContainer/FContainer";



const ProductBalanceScreen = ({ param }) => {

    const {state} = useLocation();
    const route = useNavigate();
    const {tokenDecoded} = useContext(AuthContext);
    const [accountEditable, setAccountEditable] = useState(true);
    const [amountEditable, setAmountEdiatble] = useState(true);

    const {goToTransactionDetails} = useBillPaymentArcus();

    //TODO: REALIZAR LAS VALIDACIONES DE CAMPOS Y MOSTRAR LA CANTIDAD CON DIGITOS DE MONEDA
    const validate = Yup.object({  
        amount: Yup.string()
        .required("Monto requerido")
        // description: Yup.string()
        // .required('Ingresa un valor válido')
    })

    const deleteFromFavorites = async()=>{
        //    //let resp = await deleteShortcut(product.id)

        if (window.confirm("¿Seguro que quieres eliminar este servicio de tus favoritos?")) {
          let resp = await deleteShortcut(state.product.id,state.product.accountNumber)
          if(resp.data.code == 'PROCESS_OK'){
              route('/MainScreen')
          }
        }
        //    console.log(product);
          //  alert(
          //   "Quitar de Favoritos",
          //   "¿Seguro que quieres eliminar este servicio de tus favoritos?",
          //   [
          //     {
          //       text: "Cancelar",
          //       onPress: () => {},
          //     },
          //     { text: "Eliminar", onPress: async() => {
          //           let resp = await deleteShortcut(state.product.id,state.product.accountNumber)
          //           if(resp.data.code == 'PROCESS_OK'){
          //               route('MainScreen')
          //           }
          //     } }
          //   ]
          // );
        }



    useEffect(()=>{
        //console.log(state.balance.accountNumber)
    },[])


    const formikProductBalanceScreen = useFormik({
        initialValues: {
            paymentAccountNumber: state.balance.accountNumber,
            amount: state.balance.balance.toString(),
            description: "",
          },
        onSubmit: values => {
            const {paymentAccountNumber, amount} = values;
            let productId = "";
            if(state.product?.product?.accountNumber){
                var comeFromFavorites = true
                productId = state.product.product.id
              }else{
                var comeFromFavorites = false 
                productId = state.product.id
              }

           goToTransactionDetails({productId:productId,originCurrencyId:"484",destinationCurrencyId:"484", paymentAccountNumber, amount:parseFloat(amount,2),comeFromFavorites})
        },
        validate: (values) => {
            //console.log(values)
            const errors = {};
            return errors;
        },
    });

  
  return (
    <>
    <FContainer>
    <form onSubmit={formikProductBalanceScreen.handleSubmit} className="w-full">
    <div className="w-full  flex justify-center">
                    <img
                        src={state.product.iconUrl}
                        className="w-32 sm:w-48"
                    />
              </div>
                {
                    state.product?.product?.description ? 
                    <div>
                      <div className="font-bold text-lg text-Secondary">{state.product?.product?.description}</div>
                      <div className="font-bold text-lg">{state.product?.product?.accountNumber}</div>
                    </div>  
                    : null
                }

                <FInputt
                    type="text"
                    name="amount"
                    title={'Monto a pagar (MXN)'}
                    value={state.balance.balance.toString()}
                    formik={formikProductBalanceScreen}
                    disabled={true}
                    
                />

                <FInputt
                    type="submit"
                    title={'Continuar'}
                    formik={formikProductBalanceScreen}
            
                />


              {
                    state.product?.product?.accountNumber ? 
                    <div className="text-Secondary text-center text-lg p-4">
                      <div onClick={()=>{deleteFromFavorites()}}>Eliminar de favoritos</div>
                    </div>  
                    : null
                }


      </form>
    </FContainer>

    </>
  );
};

export default ProductBalanceScreen;
